import React, { Fragment } from 'react';
import styled from 'styled-components';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@mui/material';
import { 
  MEASURE_IDS,
  CLASSIFICATIONS_CAPACITY,
  CLASSIFICATIONS_REACH,
  CLASSIFICATIONS_LEARN,
  CLASSIFICATIONS_ACT,
  CLASSIFICATIONS_SOCIAL
} from '../constants';

const OPTIONS = {
  50009: CLASSIFICATIONS_CAPACITY,
  50013: CLASSIFICATIONS_REACH,
  50017: CLASSIFICATIONS_LEARN,
  50021: CLASSIFICATIONS_ACT,
  50025: CLASSIFICATIONS_SOCIAL
};

const MeasurementSelector = ({ value, onChange, questionId }) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };
  const opts = OPTIONS[questionId];
  return <Container>
    <RadioGroup aria-label="gender" name="gender1" value={value} onChange={handleChange}>
      { opts.map(({ label, ids }) => (
        <Table>
          <span className="title-3">{ label }</span>
          { ids.map(({category, list }) => {
            return (<Fragment>
              <Div size="10"/>
              { list.map((id) => (
                <Div>
                  <RadioLabel value={id} label={MEASURE_IDS[id]}/>
                </Div>
              )) }
            </Fragment>);
          })}
        </Table>
      ))}
    </RadioGroup>
  </Container>;
};

const Container = styled.div`
  width: 100%;
`;
const Table = styled.div`
  width: 100%;
  min-height: 50px;
  background-color: #fff;
  border: solid 1px #ccc;
  padding: 16px;
  margin-bottom: 10px;
`;
const Div = styled.div`
  width: 100%;
  margin-top: ${props => props?.size||0}px;
`;
export const RadioLabel = styled(FormControlLabel).attrs(({ checked }) => ({
  control: <Radio {...{ checked }}/>
}))`
  transform: translateY(-2px);
  padding-left: 6px;
  .MuiRadio-root {
    padding: 4px !important;
  }
`;

export default MeasurementSelector;
